import { useState } from "react"
import { useApp } from "../../AppProvider"
import { classNames } from "../../utils/classNames"
import { ConditionsTable } from "./ConditionsTable"

const tabs = [{ name: "Conditions", href: "#", current: true }]

export const EmailSettings = () => {
  const { orgId } = useApp()
  const [activeTab, setActiveTab] = useState("Conditions")

  const handleTabChange = (tabName: string) => {
    setActiveTab(tabName)
  }

  return (
    <div className="card">
      <div className="mb-2">
        <h1 className="text-lg font-semibold text-gray-900">Email settings</h1>
        <p className="mt-1 text-sm text-gray-600">
          Manage email templates and messaging settings for your organization.
        </p>
      </div>

      <div>
        <div className="block sm:hidden">
          {/* Mobile dropdown */}
          <select
            value={activeTab}
            onChange={(e) => handleTabChange(e.target.value)}
            aria-label="Select a tab"
            className="focus:outline-primary-600 col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2">
            {tabs.map((tab) => (
              <option key={tab.name} value={tab.name}>
                {tab.name}
              </option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav aria-label="Tabs" className="-mb-px flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => handleTabChange(tab.name)}
                  aria-current={activeTab === tab.name ? "page" : undefined}
                  className={classNames(
                    activeTab === tab.name
                      ? "border-primary-500 text-primary-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                    "border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap",
                  )}>
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>
        </div>
      </div>

      {activeTab === "Conditions" ? (
        <div className="mt-6">
          {orgId ? (
            <ConditionsTable organizationId={orgId} />
          ) : (
            <div className="py-12 text-center">
              <p className="text-gray-500">Organization not found</p>
            </div>
          )}
        </div>
      ) : null}
    </div>
  )
}
